// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector } from '@angular/core'; //_splitter_
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms'; //_splitter_
import { Router } from '@angular/router'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
import { DataService } from 'app/sd-services/DataService'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-getDetails',
  templateUrl: './getDetails.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class getDetailsComponent {
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    this.page.dep.FormBuilder = this.__page_injector__.get(FormBuilder); //FormBuilder
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_CIhvDgi1ngY7gZG1(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_CIhvDgi1ngY7gZG1(bh) {
    try {
      bh = this.sd_JF2mMcgqkYkfla19(bh);
      //appendnew_next_sd_CIhvDgi1ngY7gZG1
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_CIhvDgi1ngY7gZG1');
    }
  }

  onGenerateReport(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_lUJvuFYu6D3QAL7L(bh);
      //appendnew_next_onGenerateReport
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_RnBILe8LxKsemb25');
    }
  }

  fetchAddress(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_JCMLgg7QHl7NS783(bh);
      //appendnew_next_fetchAddress
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_DU5YMOFVWg9xtQmJ');
    }
  }

  selectedOption(event: any = undefined, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { event };
      bh.local = {};
      bh = this.sd_GpnDuuK9sV2aZHQS(bh);
      //appendnew_next_selectedOption
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_AHd15fSvZtekiAYx');
    }
  }
  //appendnew_flow_getDetailsComponent_start

  sd_JF2mMcgqkYkfla19(bh) {
    try {
      bh = this.sd_sGfacBTFIQVpoMd7(bh);
      //appendnew_next_sd_JF2mMcgqkYkfla19
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_JF2mMcgqkYkfla19');
    }
  }

  sd_sGfacBTFIQVpoMd7(bh) {
    try {
      bh = this.sd_Yg0ndNTrWmBsT1aQ(bh);
      //appendnew_next_sd_sGfacBTFIQVpoMd7
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_sGfacBTFIQVpoMd7');
    }
  }

  sd_Yg0ndNTrWmBsT1aQ(bh) {
    try {
      const page = this.page;
      page.invokeReportForm = new FormGroup({
        lob: new FormControl(
          { value: '', disabled: false },
          Validators.required
        ),
        state: new FormControl('', Validators.required),
        transaction: new FormControl('', Validators.required),
        annualized_term_number: new FormControl('', Validators.required),
        firstName: new FormControl('', Validators.required),
        middleName: new FormControl(''),
        lastName: new FormControl('', Validators.required),
        pni_address1: new FormControl('', Validators.required),
        pni_address2: new FormControl(''),
        pni_city: new FormControl('', Validators.required),
        pni_state: new FormControl('', Validators.required),
        pni_zip: new FormControl('', Validators.required),
      });

      page.addressData = [];
      bh = this.sd_IQlI33umyksfeJHi(bh);
      //appendnew_next_sd_Yg0ndNTrWmBsT1aQ
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_Yg0ndNTrWmBsT1aQ');
    }
  }

  async sd_IQlI33umyksfeJHi(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.getMethod(
        'fetch-app-config'
      );
      this.page.fetchConfigRes = outputVariables.local.result;

      //appendnew_next_sd_IQlI33umyksfeJHi
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_IQlI33umyksfeJHi');
    }
  }

  sd_lUJvuFYu6D3QAL7L(bh) {
    try {
      const page = this.page;
      const { firstName, middleName, lastName, ...rest } =
        page.invokeReportForm.value;

      bh.body = {
        pni_name: [firstName, middleName, lastName]
          .filter((part) => !!part && part.trim() !== '')
          .join(' '),
        ...rest,
      };
      bh = this.sd_1mrUJd4aRq3UiHu8(bh);
      //appendnew_next_sd_lUJvuFYu6D3QAL7L
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_lUJvuFYu6D3QAL7L');
    }
  }

  async sd_1mrUJd4aRq3UiHu8(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.postMethod(
        'fetch-report',
        bh.body
      );
      this.page.fetchRes = outputVariables.local.result;

      bh = this.sd_1VvMZszEyElU2Acd(bh);
      //appendnew_next_sd_1mrUJd4aRq3UiHu8
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_1mrUJd4aRq3UiHu8');
    }
  }

  sd_1VvMZszEyElU2Acd(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);
      DataServiceInstance['fetchRes'] = this.page.fetchRes;
      bh = this.sd_oG8btA1y8IZTcRio(bh);
      //appendnew_next_sd_1VvMZszEyElU2Acd
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_1VvMZszEyElU2Acd');
    }
  }

  async sd_oG8btA1y8IZTcRio(bh) {
    try {
      const { paramObj: qprm, path: path } =
        this.sdService.getPathAndQParamsObj('/home/process-log');
      await this.__page_injector__
        .get(Router)
        .navigate([this.sdService.formatPathWithParams(path, undefined)], {
          queryParams: Object.assign(qprm, ''),
        });
      //appendnew_next_sd_oG8btA1y8IZTcRio
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_oG8btA1y8IZTcRio');
    }
  }

  sd_JCMLgg7QHl7NS783(bh) {
    try {
      const page = this.page;
      if (
        page.invokeReportForm.value.pni_address1 &&
        page.invokeReportForm.value.pni_address1.length > 3
      ) {
        bh.body = { address: page.invokeReportForm.value.pni_address1 };
      }

      bh = this.sd_NWbIo9bGkp6ExzjY(bh);
      //appendnew_next_sd_JCMLgg7QHl7NS783
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_JCMLgg7QHl7NS783');
    }
  }

  sd_NWbIo9bGkp6ExzjY(bh) {
    try {
      if (
        this.sdService.operators['nnull'](
          bh.body,
          undefined,
          undefined,
          undefined
        )
      ) {
        bh = this.sd_8dvL03QuXyjZ3Ww7(bh);
      }

      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_NWbIo9bGkp6ExzjY');
    }
  }

  async sd_8dvL03QuXyjZ3Ww7(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);

      let outputVariables = await DataServiceInstance.postMethod(
        'fetch-address-prediction',
        bh.body
      );
      this.page.addressData = outputVariables.local.result;

      //appendnew_next_sd_8dvL03QuXyjZ3Ww7
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_8dvL03QuXyjZ3Ww7');
    }
  }

  sd_GpnDuuK9sV2aZHQS(bh) {
    try {
      const page = this.page;
      const { event } = bh.input;

      const match = page.addressData.find(
        (item) =>
          `${item.main_address}${item.secondary_address}` === event.option.value
      );

      if (match) {
        const parts = match.secondary_address.split(',').map((p) => p.trim());

        page.invokeReportForm
          .get('pni_address1')
          ?.setValue(match.main_address || '');
        page.invokeReportForm.get('pni_city')?.setValue(parts[0] || '');
        page.invokeReportForm.get('pni_state')?.setValue(parts[1] || '');
      }
      //appendnew_next_sd_GpnDuuK9sV2aZHQS
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_GpnDuuK9sV2aZHQS');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_getDetailsComponent_Catch
}
